import { encode, Encoding, decode } from '../../../utils/encoder.js';
export default function genWrappedField(tag) {
  return {
    serialize(payload, {
      packEntry
    }) {
      return decode(packEntry({
        tag,
        payload
      }));
    },
    deserialize(buffer, {
      unpackEntry
    }) {
      return unpackEntry(encode(buffer, Encoding.Bytearray), tag).payload;
    },
    recursiveType: true
  };
}
//# sourceMappingURL=wrapped.js.map